<template>
    <Drawer
            title="增加设备配件" v-model="_value" width="90" @on-visible-change="visibleChange">
        <Form ref="loginForm" :model="positioningDeviceFittings">
<!--            <div style="height: 100%;border: 1px solid #dcdee2;">-->
<!--                <Split v-model="split1">-->
<!--                    <div slot="left" class="demo-split-pane">-->
                        <FormItem prop="positioningdevicemodel">
                            <label>定位设备类型：</label>
                            <Select placeholder="请选择设备类型" style="display: inline-block; width: 130px;" @on-change="selectPositioningDeviceInfo"
                                    v-model="positioningDeviceFittings.positioningDeviceModelId"  size="small"
                            >
<!--                                <Option v-for="(option, index) in positioningDeviceType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>-->
                                <Option v-for="(option, index) in positioningDeviceType" :value="option.id" :key="option.id">{{option.name}}</Option>
                            </Select>
                            <Checkbox v-model="positioningDeviceFittings.lcdproperties" style="padding-left: 5px">LCD属性</Checkbox>
                        </FormItem>
                        <FormItem prop="starLightAlarm">
                            <Checkbox v-model="positioningDeviceFittings.starLightAlarm">声光报警：</Checkbox>
                            <Select placeholder="请选择声光报警类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.starLightAlarm"
                                    v-model="positioningDeviceFittings.starLightAlarmid"  size="small"
                            >
                                <Option v-for="(option, index) in starLightAlarmType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem prop="interphone">
                            <Checkbox v-model="positioningDeviceFittings.interphone">对讲机：</Checkbox>
                            <Select placeholder="请选择对讲机类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.interphone"
                                    v-model="positioningDeviceFittings.interphoneid"  size="small"
                            >
                                <Option v-for="(option, index) in interphoneType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem prop="trumpet">
                            <Checkbox v-model="positioningDeviceFittings.trumpet">喇叭：</Checkbox>
                            <Select placeholder="请选择喇叭类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.trumpet"
                                    v-model="positioningDeviceFittings.trumpetid"  size="small"
                            >
                                <Option v-for="(option, index) in trumpetType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem prop="trumpet">
                            <Checkbox v-model="positioningDeviceFittings.viewingScreen">显示屏：</Checkbox>
                            <Select placeholder="请选择显示屏类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.viewingScreen"
                                    v-model="positioningDeviceFittings.viewingScreenid"  size="small"
                            >
                                <Option v-for="(option, index) in viewingScreenType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem prop="hardDisk">
                            <Checkbox v-model="positioningDeviceFittings.hardDisk">硬盘：</Checkbox>
                            <Select placeholder="请选择硬盘类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.hardDisk"
                                    v-model="positioningDeviceFittings.hardDiskid"  size="small"
                            >
                                <Option v-for="(option, index) in hardDiskType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem prop="extensionCord">
                            <Checkbox v-model="positioningDeviceFittings.extensionCord">延长线：</Checkbox>
                            <div style="display: inline-table;">
                                <Select placeholder="延长线类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.extensionCord"
                                        v-model="positioningDeviceFittings.extensionCordOneid"  size="small"
                                >
                                    <Option v-for="(option, index) in extensionCordType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                                </Select>
                                <InputNumber v-model="positioningDeviceFittings.extensionCordOneNum" :min="0" :disabled="!positioningDeviceFittings.extensionCord" size="small" style="margin-left: 5px;width: 45px"></InputNumber>
                                <br>
                                <Select placeholder="延长线类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.extensionCord"
                                        v-model="positioningDeviceFittings.extensionCordFiveid"  size="small"
                                >
                                    <Option v-for="(option, index) in extensionCordType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                                </Select>
                                <InputNumber v-model="positioningDeviceFittings.extensionCordFiveNum" :min="0" :disabled="!positioningDeviceFittings.extensionCord" size="small" style="margin-left: 5px;width: 45px"></InputNumber>
                                <br>
                                <Select placeholder="延长线类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.extensionCord"
                                        v-model="positioningDeviceFittings.extensionCordFifteenid"  size="small"
                                >
                                    <Option v-for="(option, index) in extensionCordType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                                </Select>
                                <InputNumber v-model="positioningDeviceFittings.extensionCordFifteenNum" :min="0" :disabled="!positioningDeviceFittings.extensionCord" size="small" style="margin-left: 5px;width: 45px"></InputNumber>
                            </div>
                        </FormItem>
<!--                    </div>-->
<!--                    <div slot="right" class="demo-split-pane">-->
                        <FormItem prop="trumpet">
                            <Checkbox v-model="positioningDeviceFittings.Match">摄像头搭配：</Checkbox>
                            <InputNumber v-model="positioningDeviceFittings.cameraMatchADAS" :min="0" :disabled="!positioningDeviceFittings.Match" size="small" style="margin-left: 5px;width: 45px"></InputNumber>
                            <InputNumber v-model="positioningDeviceFittings.cameraMatch" :min="0" :disabled="!positioningDeviceFittings.Match" size="small" style="margin-left: 5px;width: 45px"></InputNumber>
                            <InputNumber v-model="positioningDeviceFittings.cameraMatchNetwork" :min="0" :disabled="!positioningDeviceFittings.Match" size="small" style="margin-left: 5px;width: 45px"></InputNumber>
                        </FormItem>
                        <FormItem prop="camera">
                            <Checkbox v-model="positioningDeviceFittings.camera">摄像头：</Checkbox>
                            <div style="display: inline-table;">
                                <Select placeholder="摄像头类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.camera"
                                        v-model="positioningDeviceFittings.cameraOneid"  size="small"
                                >
                                    <Option v-for="(option, index) in cameraType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                                </Select>
                                <InputNumber v-model="positioningDeviceFittings.cameraOneNum" :min="0" :disabled="!positioningDeviceFittings.camera" size="small" style="margin-left: 5px;width: 45px"></InputNumber>
                                <br>
                                <Select placeholder="摄像头类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.camera"
                                        v-model="positioningDeviceFittings.cameraTwoid"  size="small"
                                >
                                    <Option v-for="(option, index) in cameraType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                                </Select>
                                <InputNumber v-model="positioningDeviceFittings.cameraTwoNum" :min="0" :disabled="!positioningDeviceFittings.camera" size="small" style="margin-left: 5px;width: 45px"></InputNumber>
                                <br>
                                <Select placeholder="摄像头类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.camera"
                                        v-model="positioningDeviceFittings.cameraThreeid"  size="small"
                                >
                                    <Option v-for="(option, index) in cameraType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                                </Select>
                                <InputNumber v-model="positioningDeviceFittings.cameraThreeNum" :min="0" :disabled="!positioningDeviceFittings.camera" size="small" style="margin-left: 5px;width: 45px"></InputNumber>
                                <br>
                                <Select placeholder="摄像头类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.camera"
                                        v-model="positioningDeviceFittings.cameraFourid"  size="small"
                                >
                                    <Option v-for="(option, index) in cameraType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                                </Select>
                                <InputNumber v-model="positioningDeviceFittings.cameraFourNum" :min="0" :disabled="!positioningDeviceFittings.camera" size="small" style="margin-left: 5px;width: 45px"></InputNumber>
                                <br>
                                <Select placeholder="摄像头类型" style="display: inline-block; width: 130px;" :disabled="!positioningDeviceFittings.camera"
                                        v-model="positioningDeviceFittings.cameraFiveid"  size="small"
                                >
                                    <Option v-for="(option, index) in cameraType" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
                                </Select>
                                <InputNumber v-model="positioningDeviceFittings.cameraFiveNum" :min="0" :disabled="!positioningDeviceFittings.camera" size="small" style="margin-left: 5px;width: 45px"></InputNumber>
                            </div>
            <div style="padding-top: 20px;">
                <Button type="primary" size="small" @click="onOk" style="float: right;">添加</Button>
            </div>
                        </FormItem>
<!--                    </div>-->
<!--                </Split>-->
<!--            </div>-->
        </Form>
        <!--      <Button type="primary" style="margin-left: 5px;margin-top: 5px;" @click="onAdd">添加</Button>-->
    </Drawer>
</template>
<script>

    import Vue from 'vue'
    import { mapActions } from 'vuex'
    import store from '@/store'
    import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

    export default {
        name: 'addpositioningdevicefittingsmodal',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            initValue: null,
            terminalNumValue: null
        },
        data () {
            return {
                split1: 0.5,

                // 设备类型
                positioningDeviceType: [],
                // 声光报警类型
                starLightAlarmType: [],
                // 对讲机类型
                interphoneType: [],
                // 喇叭类型
                trumpetType: [],
                // 显示屏类型
                viewingScreenType: [],
                // 硬盘类型
                hardDiskType: [],
                // 延长线类型
                extensionCordType: [],
                // 摄像头类型
                cameraType: [],

                FittingsType: [
                    { label: '摄像头', value: 0 },
                    { label: '显示屏', value: 1 },
                    { label: '延长线', value: 2 },
                    { label: '硬盘', value: 3 },
                    { label: '声光报警', value: 4 },
                    { label: '对讲机', value: 5 },
                    { label: '喇叭', value: 6 }
                ],

                positioningDeviceFittings: {
                    positioningDeviceModelId: null,
                    terminalNum: null,
                    installOrderId: null,
                    lcdproperties: true,
                    starLightAlarm: false,
                    starLightAlarmid: null,
                    interphone: false,
                    interphoneid: null,
                    trumpet: false,
                    trumpetid: null,
                    viewingScreen: false,
                    viewingScreenid: null,
                    hardDisk: false,
                    hardDiskid: null,
                    extensionCord: false,
                    extensionCordOneid: null,
                    extensionCordOneNum: null,
                    extensionCordFiveid: null,
                    extensionCordFiveNum: null,
                    extensionCordFifteenid: null,
                    extensionCordFifteenNum: null,
                    camera: false,
                    cameraOneid: null,
                    cameraOneNum: null,
                    cameraTwoid: null,
                    cameraTwoNum: null,
                    cameraThreeid: null,
                    cameraThreeNum: null,
                    cameraFourid: null,
                    cameraFourNum: null,
                    cameraFiveid: null,
                    cameraFiveNum: null,
                    Match: false,
                    cameraMatchADAS: null,
                    cameraMatch: null,
                    cameraMatchNetwork: null
                }
            }
        },
        methods: {
            ...mapActions([
            ]),
            onOk () {
                this.$Modal.confirm({
                    title: '添加定位设备配件',
                    content: '<p>是否确认添加定位设备配件</p>',
                    onOk: () => {
                        // if (this.positioningDeviceFittings.installOrderId == null || this.positioningDeviceFittings.positioningDeviceModelId == null ){
                        if (this.positioningDeviceFittings.positioningDeviceModelId == null) {
                            this.$Message.success('设备类型不能为空')
                        } else {
                            store.dispatch('PositioningDeviceFittingsServ_AddObj', { params: this.positioningDeviceFittings }).then(() => {
                                this.$Message.success('添加定位设备配件成功')
                                this._value = false;
                                this.$emit('on-positioningdevicefittings')
                            }).catch(err => {
                                this.$Message.error(err)
                                this.$emit('on-fail')
                            })
                        }
                    },
                    onCancel: () => {
                    }
                })
            },
            // onOk () {
            //   this.$Modal.confirm({
            //     title: '修改定位设备配件',
            //     content: '<p>是否确认修改定位设备配件</p>',
            //     onOk: () => {
            //       store.dispatch('PositioningDeviceFittingsServ_ModifyObj', { params: this.positioningDeviceFittings }).then(() => {
            //         this.$Message.success('修改定位设备配件成功')
            //         this.$emit('on-success')
            //       }).catch(err => {
            //         this.$Message.error(err)
            //         this.$emit('on-fail')
            //       })
            //     },
            //     onCancel: () => {
            //     }
            //   })
            // },
            visibleChange (val) {
                // if (val) {
                    this.positioningDeviceFittings.positioningDeviceModelId = null
                    if (this._terminalNumValue == null) {
                        this.positioningDeviceFittings.terminalNum = null
                    } else {
                        this.positioningDeviceFittings.terminalNum = this._terminalNumValue
                    }
                    this.positioningDeviceFittings.installOrderId = this._initValue
                    this.positioningDeviceFittings.lcdproperties = true
                    this.positioningDeviceFittings.starLightAlarm = false
                    this.positioningDeviceFittings.starLightAlarmid = null
                    this.positioningDeviceFittings.interphone = false
                    this.positioningDeviceFittings.interphoneid = null
                    this.positioningDeviceFittings.trumpet = false
                    this.positioningDeviceFittings.trumpetid = null
                    this.positioningDeviceFittings.hardDisk = false
                    this.positioningDeviceFittings.hardDiskid = null
                    this.positioningDeviceFittings.extensionCord = false
                    this.positioningDeviceFittings.extensionCordOneNum = null
                    this.positioningDeviceFittings.extensionCordFiveid = null
                    this.positioningDeviceFittings.extensionCordFiveNum = null
                    this.positioningDeviceFittings.extensionCordFifteenid = null
                    this.positioningDeviceFittings.extensionCordFifteenNum = null
                    this.positioningDeviceFittings.cameraOneid = null
                    this.positioningDeviceFittings.cameraOneNum = null
                    this.positioningDeviceFittings.cameraTwoid = null
                    this.positioningDeviceFittings.cameraTwoNum = null
                    this.positioningDeviceFittings.cameraThreeid = null
                    this.positioningDeviceFittings.cameraThreeNum = null
                    this.positioningDeviceFittings.cameraFourid = null
                    this.positioningDeviceFittings.cameraFourNum = null
                    this.positioningDeviceFittings.cameraFiveid = null
                    this.positioningDeviceFittings.cameraFiveNum = null
                    this.positioningDeviceFittings.Match = false
                    this.positioningDeviceFittings.cameraMatchADAS = null
                    this.positioningDeviceFittings.cameraMatch = null
                    this.positioningDeviceFittings.cameraMatchNetwork = null
                    this.cameraType = []
                    this.extensionCordType = []
                    this.hardDiskType = []
                    this.starLightAlarmType = []
                    this.interphoneType = []
                    this.trumpetType = []
                    store.dispatch('PositioningDeviceTypeServ_GetAll', {
                        params: {},
                        urlparams: null
                    }).then(() => {
                        if (store.getters.get_PositioningDeviceType_GetAllResult) {
                            this.positioningDeviceType = []
                            store.getters.get_PositioningDeviceType_GetAllResult.forEach(item=>{
                                if (item.adas){
                                    this.positioningDeviceType.push(item)
                                }
                            })
                            // this.positioningDeviceType = store.getters.get_PositioningDeviceType_GetAllResult
                        }
                    }).catch(err => {
                        console.log(err)
                    })

                    store.dispatch('PositioningDeviceFittingsTypeServ_GetAll', {
                        params: {},
                        urlparams: null
                    }).then(() => {
                        if (store.getters.get_PositioningDeviceFittingsType_GetAllResult) {
                            store.getters.get_PositioningDeviceFittingsType_GetAllResult.forEach(item => {
                                // 摄像头
                                if (item.positioningDeviceFittingFirstOrderTypeId == 1) {
                                    this.cameraType.push(item)
                                }
                                if (item.positioningDeviceFittingFirstOrderTypeId == 2) {
                                    this.viewingScreenType.push(item)
                                }
                                if (item.positioningDeviceFittingFirstOrderTypeId == 3) {
                                    this.extensionCordType.push(item)
                                }
                                if (item.positioningDeviceFittingFirstOrderTypeId == 4) {
                                    this.hardDiskType.push(item)
                                }
                                if (item.positioningDeviceFittingFirstOrderTypeId == 5) {
                                    this.starLightAlarmType.push(item)
                                }
                                if (item.positioningDeviceFittingFirstOrderTypeId == 6) {
                                    this.interphoneType.push(item)
                                }
                                if (item.positioningDeviceFittingFirstOrderTypeId == 7) {
                                    this.trumpetType.push(item)
                                }
                            })
                        }
                    }).catch(err => {
                        console.log(err)
                    })

                    // store.dispatch('PositioningDeviceFittingsServ_searchbyname',{
                    //   params:{
                    //     name:this._initValue
                    //   },
                    //   urlparams:null
                    // }).then(()=>{
                    //   this.positioningDeviceFittings = store.getters.get_PositioningDeviceFittings_GetDetailResult
                    // }).catch(err=>{
                    //   console.log(err)
                    // })
                // }
            },
            selectPositioningDeviceInfo (data) {
                if (data) {
                    /**
                     * 根据选择类型，默认匹配摄像头搭配
                     */
                    store.dispatch('PositioningDeviceTypeServ_GetDetail', {
                        params: {
                            id: data
                        },
                        urlparams: null
                    }).then(res => {
                        console.log(res)
                        if (store.getters.get_PositioningDeviceType_GetDetailResult.adas) {
                            this.positioningDeviceFittings.Match = true
                            this.positioningDeviceFittings.cameraMatchADAS = 2
                            this.positioningDeviceFittings.cameraMatch = 1
                            this.positioningDeviceFittings.cameraMatchNetwork = 0
                            this.positioningDeviceFittings.hardDisk = true
                            this.positioningDeviceFittings.hardDiskid = 34
                            this.positioningDeviceFittings.extensionCord = true
                            this.positioningDeviceFittings.extensionCordOneid = 24
                            this.positioningDeviceFittings.extensionCordOneNum = 1
                            this.positioningDeviceFittings.camera = true
                            if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturer == '杭州海康汽车技术有限公司'){
                                this.positioningDeviceFittings.cameraOneid = 28
                                this.positioningDeviceFittings.cameraOneNum = 1
                            }
                            if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturer == '深圳市锐明技术股份有限公司'){
                                this.positioningDeviceFittings.cameraOneid = 27
                                this.positioningDeviceFittings.cameraOneNum = 1
                                if (store.getters.get_PositioningDeviceType_GetDetailResult.id == 19){
                                    this.positioningDeviceFittings.hardDiskid = 37
                                }
                            }
                            if (store.getters.get_PositioningDeviceType_GetDetailResult.manufacturer == '江苏中天安驰科技有限公司'){
                                this.positioningDeviceFittings.cameraOneid = 35
                                this.positioningDeviceFittings.cameraOneNum = 1
                                this.positioningDeviceFittings.hardDiskid = 36
                            }
                        } else {
                            this.positioningDeviceFittings.Match = false
                            this.positioningDeviceFittings.cameraMatchADAS = 0
                            this.positioningDeviceFittings.cameraMatch = 0
                            this.positioningDeviceFittings.cameraMatchNetwork = 0
                            this.positioningDeviceFittings.viewingScreen = false
                            this.positioningDeviceFittings.viewingScreenid = null
                            this.positioningDeviceFittings.hardDiskid = null
                            this.positioningDeviceFittings.extensionCord = false
                            this.positioningDeviceFittings.extensionCordOneid = null
                            this.positioningDeviceFittings.extensionCordOneNum = null
                            this.positioningDeviceFittings.camera = false
                            this.positioningDeviceFittings.cameraOneid = null
                            this.positioningDeviceFittings.cameraOneNum = null
                            this.positioningDeviceFittings.cameraTwoid = null
                            this.positioningDeviceFittings.cameraTwoNum = null
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                }
            }
        },
        computed: {
            _value: {
                get () {
                    return this.value
                },
                set (val) {
                    this.$emit('input', val)
                    this.$emit('change', val)
                }
            },
            _initValue: {
                get () {
                    return this.initValue
                },
                set (val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            },
            _terminalNumValue: {
                get () {
                    return this.terminalNumValue
                },
                set (val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            }
        },
        mounted () {
            this.$nextTick(() => {

            })
        }
    }
</script>
